<template>
    <div class="mainDiv">
        <!-- Input Form Component -->
        <div class="search">
            <h3>Find your address</h3>
            <EsriSearch></EsriSearch>
        </div>
        <div class="form">
            <div class="formItem">
                <div><label class="col1">Address</label><span class="reqText">&nbsp;*</span></div>
                <div class="fadeText" v-html="displayAddress"></div>
                <div v-if="!inputValid.address.value" class="reqText">{{ inputValid.address.message }}</div>
                <div v-if="!inputValid.location.value" class="reqText">{{ inputValid.location.message }}</div>
            </div>
            <!-- <div class="formItem">
                <div><label>Name</label><span class="reqText">&nbsp;*</span></div>
                <div><input type="text" v-model="formInputData.name" /></div>
                <div v-if="!inputValid.name.value" class="reqText">{{ inputValid.name.message }}</div>
            </div> -->
            <div class="formItem">
                <div><label class="col1">Select Days</label><span class="reqText">&nbsp;*</span></div>
                <input type="radio" id="both" v-model="formInputData.days" name="days" value="Both">
                <label for="both">Friday & Saturday</label><br>
                <input type="radio" id="friday" v-model="formInputData.days" name="days" value="Friday">
                <label for="friday">Friday Only</label><br>
                <input type="radio" id="saturday" v-model="formInputData.days" name="days" value="Saturday">
                <label for="saturday">Saturday Only</label>
                <!-- <div v-if="!inputValid.email.value" class="reqText">{{ inputValid.email.message }}</div> -->
            </div>
            <div class="formItem">
                <div><label class="col1">Email</label><span class="reqText">&nbsp;*</span></div>
                <div><input type="text" v-model="formInputData.email" /></div>
                <div v-if="!inputValid.email.value" class="reqText">{{ inputValid.email.message }}</div>
            </div>
            <!-- <div class="formItem">
                <div><label class="col1">Phone Number</label><span class="reqText">&nbsp;*</span></div>
                <div><input type="text" v-model="formInputData.phone" /></div>
                <div v-if="!inputValid.phone.value" class="reqText">{{ inputValid.phone.message }}</div>
            </div>
            <div class="formItem">
                <div><label class="col1">Number of Cameras</label></div>
                <div><input type="text" v-model="formInputData.cameraCount" /></div>
                <div v-if="!inputValid.cameraCount.value" class="reqText">{{ inputValid.cameraCount.message }}</div>
            </div>
            <div class="formItem">
                <div><label class="col1">Notes</label></div>
                <div><textarea v-model="formInputData.notes" /></div>
            </div> -->
            <div class="formItem">
                <div><label class="col1">Additional Pickup Information</label> <span style="margin-left: 4px; font-size: 90%; font-style: italic; color: #626262;">(e.g., Please pickup in front lobby)</span></div>
                <div><textarea v-model="formInputData.comments" /></div>
            </div>
            <div class="disclaimerDiv">
                <div class='discTitle'>Disclaimer</div>
                <p class='discText'>This information is being collected to facilitate your participation in the citywide yard sale coordinated by Parks & Recreation Services  of the City of Brandon. Your information will be used to assist with the organizing the sale and your street address will be placed on an online and printed map to advertise the sale.  Your personal information will not be used or disclosed for other purposes, unless required under The Freedom of Information and Protection of Privacy Act. If you have any questions about the collection and/or use of your personal information, please contact the Access and Privacy Officer at 204-729-2269.</p>
                <input id="disclaimerCB" type="checkbox" v-model="disclaimer" />
                <label for="disclaimerCB">I Accept</label>
            </div>
            <div><input type="button" v-bind:disabled="submitDisabled" value="SUBMIT" @click="submitData" /></div>
        </div>
    </div>
</template>

<script>
    import EsriSearch from './EsriSearch.vue';
    import axios from 'axios';

    export default {
        name: 'FormInput',
        components: { EsriSearch },
        data() {
            return {
                updated: false,
                disclaimer: false,
                inputValid: {
                    // name: { value: true, message: "Contact name is required" },
                    address: { value: true, message: "Address required" },
                    location: { value: true, message: "Invalid address location" },
                    email: { value: true, message: "Valid email address required" }
                    // phone: { value: true, message: "Valid phone number required" },
                    // notes: { value: true }
                },
                formInputData: {
                    // name: "",
                    address: "",
                    email: "",
                    latitude: 0,
                    longitude: 0,
                    days: "Both",
                    // phone: "",
                    comments: ""
                }
            };
        },
        computed: {
            config: function () {
                return this.$store.state.config;
            },
            address: function () {
                return this.formInputData.address;
            },
            displayAddress: function () {
                return this.formInputData.address || 'NO ADDRESS SELECTED';
            },
            // name: function () {
            //     return this.formInputData.name;
            // },
            days: function () {
                return this.formInputData.days;
            },
            email: function () {
                return this.formInputData.email;
            },
            // phone: function () {
            //     return this.formInputData.phone;
            // },
            // notes: function () {
            //     return this.formInputData.notes;
            // },
            comments: function () {
                return this.formInputData.comments;
            },
            currLocation: function () {
                return this.$store.state.currItem;
            },
            submitDisabled: function () {
                // return !(this.updated && this.disclaimer)
                return !(this.disclaimer)
            },
            captcha: function () {
                return this.$store.state.captcha;
            }
        },
        watch: {
            address: function (newVal, oldVal) {
                this.inputValid.address.value = true;
                this.checkUpdated(newVal, oldVal);
            },
            // name: function (newVal, oldVal) {
            //     this.inputValid.name.value = true;
            //     this.checkUpdated(newVal, oldVal);
            // },
            email: function (newVal, oldVal) {
                this.inputValid.email.value = true;
                this.checkUpdated(newVal, oldVal);
            },
            // phone: function (newVal, oldVal) {
            //     this.inputValid.phone.value = true;
            //     this.checkUpdated(newVal, oldVal);
            // },
            // notes: "checkUpdated",
            currLocation: function (newVal) {
                if (newVal != null)
                    this.updateInputData();
            }
        },
        methods: {
            emptyFormData: function () {
                return {
                    // name: "",
                    address: "",
                    email: "",
                    latitude: 0,
                    longitude: 0
                    // phone: "",
                    // notes: ""
                };
            },
            checkUpdated: function (newVal, oldVal) {
                if (oldVal && newVal !== oldVal)
                    this.updated = true;
            },
            emailValidator: function (email) {
                // Check if valid email address
                if (!email.match(/^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/))
                    return false;

                return true;
            },
            phoneValidator: function (phone) {
                // Add in phone pattern to match against
                if (!phone.match(/^(([1][- ]?)?\(?\d\d\d\)?[- ]?\d\d\d[- ]?\d\d\d\d)?$/))
                    return false;

                return true;
            },
            coordinateValidator: function (latitude, longitude) {
                try {
                    let lat = Number(latitude);
                    let lon = Number(longitude);

                    if (Number.isNaN(lat) || Number.isNaN(lon) || Number.isInteger(lat) || Number.isInteger(lon))
                        return false;
                } // try
                catch {
                    return false;
                } // catch

                return true;
            },
            validateInput: function () {
                let validValues = Object.values(this.inputValid);
                validValues.forEach((input) => input.value = true);

                // if (!this.formInputData.name)
                //     this.inputValid.name.value = false;

                if (!this.formInputData.address)
                    this.inputValid.address.value = false;

                if (!this.coordinateValidator(this.formInputData.latitude, this.formInputData.longitude))
                    this.inputValid.location.value = false;

                if (!this.formInputData.email || !this.emailValidator(this.formInputData.email))
                    this.inputValid.email.value = false;

                // if (!this.phoneValidator || !this.phoneValidator(this.formInputData.phone))
                //     this.inputValid.phone.value = false;

                return validValues.filter((input) => { return input.value ? false : true }).length === 0;
            },
            submitData: async function () {
                let valid = this.validateInput();

                if (valid) {
                    let captchaResult = this.checkCaptcha();

                    if (captchaResult) {
                        const url = this.config.submitUrl;
                        let response;
                        try {
                            response = await axios.post(url, JSON.stringify(this.formInputData), {
                                headers: { 'Content-Type': 'application/json' }
                            });
                        } // try
                        catch (error) {
                            response = { data: { error: true, message: "Connection error submitting data." } };
                        } // catch

                        this.$emit('data-submitted', response.data);
                    } // if
                    else {
                        let captchaToken = await this.captcha.execute("CityYardSale");
                        this.$store.commit('setCaptchaToken', captchaToken);

                        this.$emit('data-submitted', {
                            message: "reCaptcha check failed. Please submit the form again.",
                            error: true
                        });
                    } // else
                } // if
                else {
                    this.$emit('data-submitted', {
                        message: "Validation error. Please ensure all required form fields are filled in correctly.",
                        error: true
                    });
                } // else
            },
            updateInputData() {
                for (const key in this.currLocation) {
                    if ((this.currLocation[key] || key === "address") && this.currLocation[key] !== this.formInputData[key]) {
                        this.formInputData[key] = this.currLocation[key];
                    } // if
                } // for..in
            },
            checkCaptcha: async function () {
                let response = await axios.get(`${this.captcha.handlerUrl}?captchaToken=${this.captcha.token}`);

                if (response.data && response.data.score)
                    return response.data.success && response.data.score >= 0.5;
                else
                    return false;
            }
        },
        mounted() {

        } // mounted
    }
</script>

<style scoped>
    h2 {
        margin-top: 0px;
    }
    .mainDiv {
        /*position: absolute;*/
        /* padding: 8px; */
        width: 100%;
        display: inline-block;
        /*top: 81px;
        left: 0px;
        bottom: 0px;*/
    }
    .search {
        padding-bottom: 20px;
    }
    .formItem {
        padding-bottom: 8px;
    }
    .mapData {
        width: 100%;
        font-size: 90%;
        padding-bottom: 8px;
    }
    .dataItem {
        display: flex;
        align-items: center;
    }
    .dataLabel {
        width: 20%;
        color: black;
        font-weight: 600;
    }
    .dataValue {
        color: darkslategray;
    }
    .itemButton {
        font-size: 80%;
        padding: 3px;
        margin-left: 32px;
    }
    .disclaimerDiv {
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .fadeText {
        font-size: 90%;
        color: gray;
    }
    .reqText {
        color: darkred;
    }
    .discTitle {
        font-size: 110%;
        font-weight: 600;
    }
    .discText {
        font-style: italic;
    }
    input[type=radio] {
        width: 16px;
        height: 16px;
        margin: 4px 8px;
        margin-right: 16px;
    }
</style>